import { SystemUser } from './system-user';

export class InternalBookingComment {

    constructor(
        public body: string,
        public isModified: boolean, 
        public id?: number,
        public created?: Date,
        public createdBy?: SystemUser,
        public lastModified?: Date,
        public lastModifiedBy?: SystemUser
    ){}
}
